export default __webpack_public_path__ + "static/media/joys550_installation_diagram.6febf319.png";